import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const BankDetailsSection = ({ formData, handleNestedChange }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Bank Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Bank Name</Label>
          <Input 
            value={formData.bank_details.bank_name} 
            onChange={(e) => handleNestedChange('bank_details', 'bank_name', e.target.value)} 
            data-testid="bank-name-input"
          />
        </div>
        <div>
          <Label>Account Number</Label>
          <Input 
            value={formData.bank_details.account_number} 
            onChange={(e) => handleNestedChange('bank_details', 'account_number', e.target.value)} 
            data-testid="bank-account-input"
          />
        </div>
        <div className="md:col-span-2">
          <Label>IBAN</Label>
          <Input 
            value={formData.bank_details.iban} 
            onChange={(e) => handleNestedChange('bank_details', 'iban', e.target.value)} 
            data-testid="bank-iban-input"
          />
        </div>
      </div>
    </div>
  );
};

export default BankDetailsSection;
